// Estilos compartilhados das telas de autenticação — tema escuro da marca
// ORIGINEI (fundo preto, campos translúcidos, foco/ação laranja #ff620c).
// Usado por LoginPage e ForgotPasswordPage para manter consistência visual.

/** Fundo das telas de auth (preto da marca). */
export const AUTH_PANEL_BG = '#0A0A0A'
/** Superfície levemente elevada (cards) sobre o fundo. */
export const AUTH_CARD_BG = '#121212'

/** Rótulo de campo sobre fundo escuro. */
export const fieldLabelSx = {
  display: 'block',
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: 'rgba(255,255,255,0.92)',
  mb: 0.75,
  letterSpacing: '-0.01em',
}

/** Input (OutlinedInput) no tema escuro, com foco laranja. */
export const fieldInputSx = {
  borderRadius: '10px',
  backgroundColor: 'rgba(255,255,255,0.04)',
  color: '#FFFFFF',
  '& input': { color: '#FFFFFF' },
  '& input::placeholder': { color: 'rgba(255,255,255,0.38)', opacity: 1 },
  '& fieldset': { borderColor: 'rgba(255,255,255,0.14)' },
  '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.30) !important' },
  '&.Mui-focused fieldset': { borderColor: '#ff620c !important', borderWidth: '1.5px !important' },
  '&.Mui-focused': { backgroundColor: 'rgba(255,255,255,0.06)' },
}

/** Botão primário laranja da marca. */
export const primaryBtnSx = {
  height: 48,
  borderRadius: '10px',
  fontSize: '0.9375rem',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  textTransform: 'none',
  backgroundColor: '#ff620c',
  boxShadow: '0 4px 12px rgba(255, 98, 12,0.30)',
  '&:hover': {
    backgroundColor: '#e0560a',
    boxShadow: '0 6px 16px rgba(255, 98, 12,0.40)',
  },
  '&.Mui-disabled': { backgroundColor: 'rgba(255, 98, 12,0.35)', color: 'rgba(255,255,255,0.65)' },
}
